<template>
  <div>
    <a-form-model class="ec-register-form switch-form" :model="form" :rules="rules" ref="registerForm" hideRequiredMark :colon="false" labelAlign="left">
      <!-- 手机号 -->
      <a-form-model-item prop="phone" :label="$t('common_form_phone')" htmlFor="phone" class="input-addon-before-form-item">
        <a-input
          autoComplete="off"
          v-model="form.phone"
          :maxLength="11"
          @keyup="form.phone = form.phone.replace(/[^\d]/g, '')"
          v-forlogin="'phone'"
        >
        <template #addonBefore>
          <PhoneCode @changeCode="changeCode" :getPopupContainer="() => $el" />
        </template>
        </a-input>
      </a-form-model-item>
      <!-- 右侧验证码 -->
      <a-form-model-item prop="imgCode" :label="$t('common_form_identifying_code')" htmlFor="imgCode" v-if="showImgCode">
        <a-input autoComplete="off" v-model="form.imgCode" :maxLength="4" v-forlogin="'imgCode'">
          <span slot="suffix" style="width:56px;height:33px;background:rgb(253, 253, 253);">
            <a-spin v-if="imgCodeLoading" size="small" style="margin-left: 25px; margin-top: 9px;" />
            <img v-else :src="imgCodeData" style="cursor:pointer; width: 100%; height: 100%" @click="getImgCode" />
          </span>
        </a-input>
      </a-form-model-item>
      <!-- 短信验证码 -->
      <a-form-model-item prop="shortMessageCode" :label="$t('common_form_sms_code')" htmlFor="shortMessageCode">
        <a-input :maxLength="6" autoComplete="off" v-model="form.shortMessageCode" v-forlogin="'shortMessageCode'">
          <a-spin slot="suffix" :spinning="isCodeLoading && !timing">
            <a-button v-show="!timing" id="captcha-button" type="link">{{$t('common_btn_send_ver')}}</a-button>
            <span v-show="timing">{{timing}} s</span>
          </a-spin>
        </a-input>
      </a-form-model-item>
      <!-- 公司名称（选填） -->
      <a-form-model-item prop="companyName" :label="$t('common_form_company_name')" htmlFor="companyName">
        <a-input :maxLength="50" autoComplete="off" v-model="form.companyName" v-forlogin="'companyName'" />
      </a-form-model-item>
      <!-- 邀请码（选填） -->
      <a-form-model-item prop="inviteCode" :label="$t('common_form_Invitation')" htmlFor="inviteCode">
        <a-input v-model="form.inviteCode" autoComplete="off" v-forlogin="'inviteCode'"></a-input>
      </a-form-model-item>
    </a-form-model>
    <!-- 协议 -->
    <div class="ec-register-agreement" >
      <a-checkbox class="login-form__checkbox" v-model="agreement">
        <span>{{ $t('common_login_I_read_agress') }}</span>
        <a-button type="link" @click="$emit('agreement', 'agreementVisible')">{{ $t('common_login_ServiceAgreement') }}</a-button>
        <span>{{ $t('common_conj_and') }}</span>
        <a-button type="link" @click="$emit('agreement', 'policyVisible')">{{ $t('common_login_PrivacyPolicy') }}</a-button>
      </a-checkbox>
    </div>
    <a class="ec-register-submit" :class="{'ec-register-submit__loading': submitLoading}" @keyup.13="onSubmit">
      <a-spin v-if="submitLoading">
        <a-icon slot="indicator" type="loading" style="font-size: 24px;  color: #fff" spin />
      </a-spin>
      <div style="flex: 1; text-align:center" v-else @click="onSubmit">{{ $t('common_login_register') }}</div>
    </a>
    <div style="display: flex; justify-content: center; margin-top: 10px;">
      <!-- <a class="ec-register-submit" style="background: #fff; color: #007BFC; font-size: 14px; margin-top: 10px" @click="$emit('to', 'login')">
        {{ $t('common_login_title') }}
      </a> -->
      <div style="margin: 1px;height: 30px;font-size:14px;font-weight:400; display: flex; align-items: center;">{{ $t('common_login_register_tip') }}</div>
        <a-button style="padding: 0 4px;" type="link" @click="$emit('to', 'login')">
          <!-- <icon-font type="gb-icon-account-circle-line"></icon-font> -->
          {{ $t('common_login_login_btn') }}
        </a-button>
    </div>

    <!-- 验证码容器 -->
    <div id="captcha-element"></div>
  </div>
</template>

<script>
import md5 from 'md5'
import mixins from '../mixins'
import { debounce } from '@/utils/util'
import {
  LoginCodeAvatar, // 验证码
  LoginCheckImgCode // 手机验证码
} from '@/api/sso/code'
import { register } from '@/api/sso/user'
import PhoneCode from '@/components/PhoneCode/phoneCode'
import {
  querySystemExtListForSub
} from '@/api/index'
import { SSO_SYS_USER_SAIL } from '@/store/mutation-types'

export default {
  components: {
    PhoneCode
  },
  mixins: [mixins],
  data () {
    const validatePhone = (rule, value, callback) => {
      if (value.length < 7 || value.length > 12 || !/^[\d]+$/.test(value)) {
        callback(new Error(this.$t('common_form_please_enter', [this.$t('common_form_正确的手机号码')])))
      } else {
        callback()
      }
    }
    return {
      form: {
        phoneCode: '86',
        phone: '',
        companyName: ''
      },
      rules: {
        phone: [
          { required: true, message: this.$t('common_form_please_enter', [this.$t('common_form_phone')]), trigger: [] },
          { validator: validatePhone, trigger: [] }
        ],
        imgCode: [
          { required: true, message: this.$t('common_form_please_enter', [this.$t('common_form_identifying_code')]), trigger: [] },
          {
            length: 4, message: this.$t('common_form_please_enter', [this.$t('common_form_four-digit')]), trigger: []
          }
        ],
        companyName: { required: false, message: this.$t('common_form_please_enter', [this.$t('common_form_company_name')]), trigger: [] },
        shortMessageCode: { required: true, message: this.$t('common_form_please_enter', [this.$t('common_form_sms_code')]), trigger: [] }
      },
      showImgCode: false,
      imgCodeLoading: false,
      imgCode: '',
      imgCodeData: '',
      timing: 0,
      isCodeLoading: false,
      agreement: false, // 请阅读并勾选协议
      submitLoading: false,
      successTime: 3,
      timer: null
      // open: false
    }
  },
  methods: {
    changeCode (val) {
      this.form.phoneCode = val
    },
    // 轮询注册状态
    loopRegisterStatus () {
      querySystemExtListForSub({
        paging: false,
        serviceCode: 'ERP+',
        fromFrontPage: true
      }).then(({ dataList }) => {
        const serviceInfoExt = dataList?.[0]?.serviceInfoExt || []
        const isExit = serviceInfoExt.find(item => item.systemCode === 'ERP' && item.serviceDeploy === 4)

        if (isExit) { // 如果存在，则注册成功
          const serviceId = isExit.serviceId
          const timer = setInterval(() => {
            this.successTime -= 1
            if (this.successTime === 0) {
              clearInterval(timer)
              this.$emit('done', { serviceId })
            }
          }, 1000)

          this.$info({
            getContainer: () => this.$el,
            icon: () => (<icon-font type="gb-icon-check1"></icon-font>),
            title: this.$t('common_login_注册成功'),
            content: () => (`${ this.$t('common_login_初始密码将通过短信发送到您的手机') }(${ this.successTime }s)`),
            okText: this.$t('common_login_title'),
            onOk: () => {
              this.$emit('done', { serviceId })
            }
          })
        } else {
          this.timer = setTimeout(() => {
            clearTimeout(this.timer)
            this.timer = null
            this.loopRegisterStatus()
          }, 10000)
        }
      })
    },
    onSubmit () {
      if (!this.agreement) {
        this.$message.warning(this.$t('common_form_请阅读并勾选协议'))
        return
      }
      this.$refs['registerForm'].validate((flag, errors) => {
        if (!flag) return this.$message.error(errors[Object.keys(errors)[0]][0].message)
        this.submitLoading = true
        const { source, free, businessUserId, systemCodes, linkId } = this.$route.query
        const params = {
          ...this.form,
          eosSource: source,
          subjectMode: free ? 1 : undefined,
          linkId: linkId || '',
          businessUserId: businessUserId ? `+${businessUserId}` : undefined,
          systemCodes: systemCodes ? systemCodes.split(',') : undefined,
          smsType: 'REGISTER',
          shareCode: this.$route.query.share_code || undefined,
          sourceSystem: process.env.VUE_APP_SOURCE_SYSTEM,
          source: process.env.VUE_APP_SOURCE
        }
        register(params).then(() => {
          // 轮询后台注册状态
          this.loopRegisterStatus()
        }).catch(() => {
          this.submitLoading = false
        })
      })
    },
    getImgCode () {
      this.imgCodeLoading = true
      debounce(() => {
        LoginCodeAvatar().then(({ data }) => {
          this.form.imgCodeKey = data.imgCodeKey
          this.imgCodeData = data.imgCodeData
        })
          .finally(() => {
            this.imgCodeLoading = false
          })
      }, 500)
    },
    getShortMessageCode (captchaVerifyParam) {
      const {
        form: {
          phone,
          phoneCode,
          imgCode,
          imgCodeKey
        }
      } = this
      let error = false
      this.$refs['registerForm'].validateField(['phone', 'imgCode'], message => {
        if (message) {
          error = true
          this.$message.warning(message)
        }
      })
      if (error) return
      this.isCodeLoading = true
      const timestamp = Date.now()
      const sign = md5(timestamp + phone + SSO_SYS_USER_SAIL)
      LoginCheckImgCode({
        captchaVerifyParam,
        imgCode,
        imgCodeKey,
        phoneCode,
        phone,
        smsType: 'REGISTER',
        sign,
        timestamp
      }).then(() => {
        this.timing = 60
        this.countdown()
      }).catch(({ message, data }) => {
        if (data?.phoVc) {
          this.showImgCode = true
        }
        this.showImgCode && this.getImgCode()
      }).finally(() => {
        this.isCodeLoading = false
      })
    },
    countdown () {
      const { timing } = this
      if (timing > 0) {
        setTimeout(() => {
          this.timing = timing - 1
          this.countdown()
        }, 1000)
      }
    },
    initCaptcha () {
      if (!window.initAliyunCaptcha) {
        this.$message.warning('阿里云验证码JS未加载')
        return
      }

      this.$nextTick(() => {
        window.initAliyunCaptcha({
          SceneId: 'qbz2hcw3',
          mode: 'popup',
          element: '#captcha-element',
          button: '#captcha-button',
          // 验证成功回调
          success: (captchaVerifyParam) => {
            this.getShortMessageCode(captchaVerifyParam)
          },
          // 验证失败回调
          fail: (error) => {
            console.log('验证码验证失败:', error)
          },
          slideStyle: {
            width: 360,
            height: 40
          },
          language: 'cn'
        })
      })
    },
  },
  async mounted () {
    this.form = {
      ...this.form,
      inviteCode: this.$route.query.inviteCode || '' // 邀请码
    }
    this.initCaptcha()
  }
}
</script>

<style lang="less" scoped>
@color: #077BFC;
/deep/.@{ant-prefix}-btn-primary {
  background-color: @color;
  border-color: @color;
  box-shadow: none
}
/deep/.@{ant-prefix}-select-selection {
  .@{ant-prefix}-select-selection__rendered {
    margin: 0 30px 0 0;
  }
}
.ec-register {
  &-form {
    input {
      width: 100%;
    }
  }
  &-agreement {
    margin-top: 20px;
    .@{ant-prefix}-btn-link {
      margin: 0;
      padding: 0;
      height: auto;
      line-height: unset;
    }
  }
  &-submit {
    width: 100%;
    height: 55px;
    line-height: 55px;
    background: @color;
    color: #fff;
    display: flex;
    font-size: 18px;
    border-radius: 2px;
    justify-content: center;
    justify-items: center;
    align-items: center;
    margin: 30px auto 0 auto;
    transition: all 0.5s;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
    &__disable {
      background: #ddd;
      cursor: default;
    }
    &__loading {
      width: 55px;
      border-radius: 55px;
      background: fade(@color, 75%);
    }
  }
}
</style>
